var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"info-component-wrapper"},[_c('IconInfoCircle',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.tooltipObject),expression:"tooltipObject",modifiers:{"hover":true}}],staticClass:"info-icon",attrs:{"title":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }